module.exports = __webpack_public_path__ + "img/Img2.f3aee555.jpg";